import React from 'react';
import PropTypes from 'prop-types';
import { useApolloClient, gql } from '@apollo/client';
import { Typeahead } from '@administrate/piston-ux';
import { withTranslation } from 'react-i18next';
import { extractNodes } from './pickerHelpers';

const GET_LEARNING_TAGS = gql`
  query getLearningTags(
    $filters: [LearningTagFieldFilter!]!
    $order: LearningTagFieldOrder!
  ) {
    learningTags(filters: $filters, order: $order) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

const LearningTagPicker = ({ t, name, onChange }) => {
  const client = useApolloClient();

  const loadOptions = async inputValue => {
    const { data } = await client.query({
      query: GET_LEARNING_TAGS,
      variables: {
        filters: [
          {
            field: 'name',
            operation: 'like',
            value: `%${inputValue}%`,
          },
        ],
        order: {
          field: 'name',
          direction: 'asc',
        },
      },
    });

    return extractNodes(data?.learningTags);
  };

  return (
    <Typeahead
      name={name}
      multiple
      label={t('builder:learningTags')}
      loadOptions={loadOptions}
      formatter={learningTag => learningTag.name}
      staticFormatter={learningTag => learningTag.name}
      onChange={onChange}
    />
  );
};

LearningTagPicker.propTypes = {
  t: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withTranslation()(LearningTagPicker);
